export default "__VITE_ASSET__Dnx_kpRb__"